import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import api from '../../../../services/api';
import { useAnimalFilters } from '../../../../hooks/animalFilters';
import { useOnlineStatus } from '../../../../hooks/onlineStatus';
import renderAnimalFiltersText from '../../../../utils/renderAnimalFiltersText';

import OfflineMessage from '../../../../components/OfflineMessage';
import BackHeader from '../../../../components/BackHeader';
import { H2, Skeleton } from '../../../../components/Generic';
import { Container, Content, RowItem } from './styles';

const SearchDetails: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>({});

  const { id_property }: any = useParams();
  const { animalFilters } = useAnimalFilters();
  const isOnline = useOnlineStatus();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);

      const response = await api.get(`/statistics`, {
        headers: {
          propriedade_id: id_property,
        },
        params: {
          ...animalFilters,
          pertencentes: !!animalFilters.pertencentes,
          cursor_id: '',
          key: '',
        },
      });

      console.log(response.data);

      setData(response.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <BackHeader title="Pesquisar animal" />

      {!isOnline ? (
        <OfflineMessage />
      ) : loading ? (
        <Content>
          <H2>Detalhes</H2>

          <p>Procurando por: {renderAnimalFiltersText(animalFilters)}</p>

          <RowItem>
            <p>Número de machos</p>
            <strong>
              <Skeleton style={{ width: 60, height: 16 }} />
            </strong>
          </RowItem>

          <RowItem>
            <p>Número de fêmeas</p>
            <strong>
              <Skeleton style={{ width: 60, height: 16 }} />
            </strong>
          </RowItem>

          <RowItem>
            <p>Peso médio</p>
            <strong>
              <Skeleton style={{ width: 60, height: 16 }} />
            </strong>
          </RowItem>

          <RowItem>
            <p>Idade média</p>
            <strong>
              <Skeleton style={{ width: 60, height: 16 }} />
            </strong>
          </RowItem>
        </Content>
      ) : (
        <Content>
          <H2>Detalhes</H2>

          <p>Procurando por: {renderAnimalFiltersText(animalFilters)}</p>

          <RowItem>
            <p>Número de machos</p>
            <strong>{data?.machos || '--'}</strong>
          </RowItem>

          <RowItem>
            <p>Número de fêmeas</p>
            <strong>{data?.femeas || '--'}</strong>
          </RowItem>

          <RowItem>
            <p>Peso médio</p>
            <strong>
              {(data?.peso_medio && `${data.peso_medio}kg`) || '--'}
            </strong>
          </RowItem>

          <RowItem>
            <p>Idade média</p>
            <strong>{(data?.idade_media && data.idade_media) || '--'}</strong>
          </RowItem>
        </Content>
      )}
    </Container>
  );
};

export default SearchDetails;
